<template>
    <div class="container vstack position-relative">
        <!-- banner -->
        <div v-if="bannerList.length > 0" class="w-100 banner-container position-relative" >

            <swiper
                :modules="swiperModules"
                :slides-per-view="1"
                :space-between="0"
                :loop="true"
                :speed="600"                                   
                :autoplay="{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }"
                @swiper="onSwiper"
                @realIndexChange="onSlideChange"
                >
                <swiper-slide v-for="banner in bannerList" :key="banner.idx" @click="$commonUtils.openUrlInNewTab(banner.landing_type, banner.landing_idx, banner.url)">
                    <img :src="$commonUtils.getImageUrl('banners/' + banner.image)" class="w-100 ar-31 cursor-pointer" style="object-fit:cover;" :class="{ 'br-12': !$commonUtils.checkMobile() }"/>
                </swiper-slide>
            </swiper>

            <div class="banner-slider-navigation">{{ banner_slider_idx + ' / ' + bannerList.length}}</div>
        </div>
        <!-- 퀵버튼 -->
        <div v-if="quickMenuList.length > 0" class="mt-section">
            <h3 class="fs-20 fw-700 r-container quick-menu-title">퀵메뉴</h3>
            <div class="quick-menu-wrap r-container">
            <div
                v-for="item in quickMenuList"
                :key="item.idx"
                class="quick-menu-item vstack text-center cursor-pointer"
                @click="onQuickMenuClick(item.idx)"
            >
                <div class="quick-menu-icon-wrap">
                    <img :src="$commonUtils.getImageUrl(item.category_image)" class="quick-menu-icon" />
                </div>
                <p class="fs-16 fw-500 mt-2 quick-menu-label">{{ item.category_name }}</p>
            </div>
            </div>
        </div>

        <!-- recommended -->
        <div class="mt-section" >

            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">이달의 추천 입양 동물</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('recommended')">더보기 ></span>
            </div>

            <swiper
                v-if="recommendedShelterList.length > 0"
                :modules="swiperModules"
                :slides-per-view="'auto'"
                :space-between="16"

                :loop="true"

                :autoplay="{ delay: 1, disableOnInteraction: false, pauseOnMouseEnter: false }"
                :speed="2000"                               
                :free-mode="false"
                :allow-touch-move="true"

                :observer="true" :observe-parents="true"     
                :key="'shelter-'+recommendedShelterList.length"
                class="marquee-swiper r-mt-1h r-container"
                >
                <swiper-slide
                    v-for="shelter, i in recommendedShelterList"
                    :key="`${shelter.idx}-${i}`"
                    class="shelter-slide text-center cursor-pointer"
                    @click="sel_shelter.idx == shelter.idx ? sel_shelter = {} : sel_shelter = shelter; getRecommendedAnimalList()"
                    >
                    <div class="shelter-image-container" :class="sel_shelter.idx == shelter.idx ? 'active' : ''">
                        <div class="shelter-image-inner">
                            <img :src="$commonUtils.getImageUrl(shelter.shelter_icon)" alt="" loading="lazy" class="shelter-image" />
                        </div>
                    </div>
                    <p class="mt-2 shelter-name fs-14 nw" :class="sel_shelter.idx == shelter.idx ? 'active' : ''">{{ shelter.shelter_short_name }}</p>

                </swiper-slide>
            </swiper>

            <swiper
                v-if="recommendedAnimalList.length > 0"
                :modules="swiperModules"
                :slides-per-view="'auto'"
                :free-mode="true"
                :scrollbar="false"
                :mousewheel="true"
                :grab-cursor="true"
                :space-between="16"
                class="hscroll-swiper r-mt-1h r-ph-16"
                >
                <swiper-slide
                    v-for="animal in recommendedAnimalList"
                    :key="animal.idx"
                    class="animal-slide cursor-pointer"
                    @click="$router.push({ name: 'AnimalDetail', params: { idx: animal.notify_number }})"
                    >
                    <div class="vstack">
                        <div class="animal-image-container">
                            <img :src="animal.more_image1 ? $commonUtils.getImageUrl('shelter/' + animal.more_image1) : animal.animal_image" />
                        </div>

                        <p class="fs-16 fw-600 mt-2 nw-dot">{{ animal.notify_number }}</p>
                        <p class="fs-16 mt-1 nw-dot">{{ animal.animal_age + ' | ' + (animal.animal_sex == 'F' ? '암컷' : (animal.animal_sex == 'M' ? '수컷' : '성별미상')) + ' | ' + animal.animal_weight  }}</p>
                    </div>
                </swiper-slide>
            </swiper>

        </div>
        <!-- donation-->
        <div v-if="donationList.length > 0" class="section-container mt-section" >
            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">포인기부</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('donation')">더보기 ></span>
            </div>

            <div class="vstack mt-3 r-container">
                <div v-for="donation in donationList" :key="donation.idx" @click="$router.push({ name: 'DonationDetail', params: { idx: donation.idx } })" class="cursor-pointer hstack pv-3">
                    <div class="w-30 position-relative">
                        <img :src="$commonUtils.getImageUrl(donation.donation_image)" class="w-100 ar-11 br-8 of-cover"/>
                        <img v-if="$commonUtils.isNewBadge(donation.new_badge_date)" src="@/assets/icon/new_badge.png" class="donation-new-badge" />
                    </div>
                    <div class="w-70 v-stack pl-16">
                        <p class="fw-600 fs-16">{{ donation.donation_title }}</p>

                        <div class="hstack mt-2 mb-2">
                            <p class="fs-14 fc-gray fw-600">{{ donation.collaborative_company }}</p>
                            <p class="fs-12 fc-white badge bg-blue ml-1">{{ donation.donation_type }}</p>
                        </div>

                        <div class="progress" role="progressbar"
                            :aria-valuenow="Math.round(progressPct(donation))"
                            aria-valuemin="0" aria-valuemax="100">
                            <div class="progress-bar" :class=" donation.state === '진행중' ? (progressPct(donation) >= 100 ? 'bg-orange' : 'bg-green') : 'bg-deep-gray' "
                                :style="{ width: progressPct(donation).toFixed(1) + '%' }">
                            </div>
                        </div>

                        <div class="hstack mt-1">
                            <p class="fs-14 fc-gray fw-600">{{ donation.comment_donation === 'ON' ? donation.comment_donation_count + ' 건 참여' : donation.participant_count + ' 건 참여' }}</p>
                            <p class="ms-auto fs-14 fw-600" :class="donation.state === '진행중' ? (progressPct(donation) >= 100 ? 'fc-orange' : 'fc-green') : 'fc-gray' ">{{ progressPct(donation) }} %</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- campaign -->
        <div v-if="campaignList.length > 0" class="section-container mt-section" >
            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">입양 캠페인</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('campaign')">더보기 ></span>
            </div>

            <swiper
                v-if="campaignList.length > 0"
                :modules="swiperModules"
                :slides-per-view="'auto'"
                :free-mode="true"
                :scrollbar="false"
                :mousewheel="true"
                :grab-cursor="true"
                :space-between="16"
                class="hscroll-swiper r-mt-1h r-ph-16"
                >
                <swiper-slide
                    v-for="campaign in campaignList"
                    :key="campaign.idx"
                    class="cursor-pointer campaign-slide"
                    @click="sel_campaign = campaign; getCampaignAnimalList()"
                    >
                    <span class="campaign-tag fs-16" :class="sel_campaign.idx == campaign.idx ? 'active' : '' ">{{ campaign.campaign_tag }}</span>

                </swiper-slide>
            </swiper>

            <swiper
                v-if="campaignAnimalList.length > 0"
                :modules="swiperModules"
                :slides-per-view="'auto'"
                :free-mode="true"
                :scrollbar="false"
                :mousewheel="true"
                :grab-cursor="true"
                :space-between="16"
                class="hscroll-swiper r-mt-1h r-ph-16"
                >
                <swiper-slide
                    v-for="animal in campaignAnimalList"
                    :key="animal.idx"
                    class="animal-slide cursor-pointer"
                    @click="$router.push({ name: 'AnimalDetail', params: { idx: animal.notify_number }})"
                    >
                
                    <div class="vstack">
                        <div class="animal-image-container">
                            <img :src="animal.more_image1 ? $commonUtils.getImageUrl('shelter/' + animal.more_image1) : animal.animal_image" />
                        </div>

                        <p class="fs-16 fw-600 mt-2 nw-dot">{{ animal.notify_number }}</p>
                        <p class="fs-16 mt-1 nw-dot">{{ animal.animal_age + ' | ' + (animal.animal_sex == 'F' ? '암컷' : (animal.animal_sex == 'M' ? '수컷' : '성별미상')) + ' | ' + animal.animal_weight  }}</p>
                    </div>
                </swiper-slide>
            </swiper>

        </div>
        <!-- review -->
        <div class="mt-section">
            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">베스트 입양 후기</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('review')">더보기 ></span>
            </div>

            <!-- 포인핸드 Pick 강조 카드 (베스트 입양후기 라벨 하단) -->
            <div v-if="pickStory" class="r-container r-mt-1h">
                <PickStoryCard :story="pickStory" :filled="true" :large="true" />
            </div>

            <div class="r-container grid-3-container r-mt-1h">
                <div
                    class="col cursor-pointer"
                    v-for="i in Math.min(6, reviewList.length)"
                    :key="reviewList[i-1]?.story_idx ?? i"
                    @click="$router.push({ name: 'StoryDetail', params: { idx: reviewList[i-1]?.story_idx }})"
                    >
                    <div class="ar-11">
                        <img :src="$commonUtils.getImageUrl(reviewList[i-1]?.story_image1)" class="of-cover br-8" />
                    </div>
                    <p class="mt-2 fs-16 nw-2-dot">{{ reviewList[i-1]?.story_title }}</p>
                </div>
            </div>
        </div>
        <!-- pawinhand news -->
        <div class="mt-section">
            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">포인핸드 소식</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('news')">더보기 ></span>
            </div>

            <swiper
                v-if="pawinhandNewsList.length > 0"
                :modules="swiperModules"
                :slides-per-view="'auto'"
                :free-mode="true"
                :scrollbar="false"
                :mousewheel="true"
                :grab-cursor="true"
                class="hscroll-swiper r-mt-1h r-ph-16"
                >
                <swiper-slide
                    v-for="story in pawinhandNewsList"
                    :key="story.story_idx"
                    class="news-slide cursor-pointer r-mr-16"
                    @click="$router.push({ name: 'StoryDetail', params: { idx: story.story_idx }})"
                    >
                
                    <div class="vstack">
                          <div class="news-image-container br-12">
                            <img :src="$commonUtils.getImageUrl(story.story_image1)" alt="" loading="lazy" />
                            <!-- 오버레이 -->
                            <div class="news-overlay">
                                <p class="news-title nw-dot">{{ story.story_title }}</p>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>

        </div>
        <!-- youtube -->
        <div class="mt-section">
            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">포인핸드 유튜브</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('youtube')">더보기 ></span>
            </div>

            <swiper
                v-if="youtubeList.length > 0"
                :modules="swiperModules"
                :slides-per-view="'auto'"
                :free-mode="true"
                :scrollbar="false"
                :mousewheel="true"
                :grab-cursor="true"
                class="hscroll-swiper r-mt-1h r-ph-16"
            >
                <swiper-slide
                    v-for="youtube in youtubeList"
                    :key="youtube.idx"
                    class="youtube-slide cursor-pointer r-mr-16"
                    @click="goYoutube(youtube)"
                    >
                
                    <div class="vstack">
                        <div class="youtube-image-container">
                            <img :src="$commonUtils.getImageUrl(youtube.image)" />
                        </div>

                        <p class="fs-16 mt-2 nw-2-dot">{{ youtube.title }}</p>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <!-- fellow -->
        <div class="mt-section">
            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">펠로우 소식</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('fellow')">더보기 ></span>
            </div>

            <div class="r-container grid-3-container r-mt-1h">
                <div
                    class="col cursor-pointer"
                    v-for="i in Math.min(6, fellowStoryList.length)"
                    :key="fellowStoryList[i-1]?.story_idx ?? i"
                    @click="$router.push({ name: 'StoryDetail', params: { idx: fellowStoryList[i-1]?.story_idx }})"
                    >
                    <div class="ar-11">
                        <img :src="$commonUtils.getImageUrl(fellowStoryList[i-1]?.story_image1)" class="of-cover br-8" />
                    </div>
                    <p class="mt-2 fs-16 nw-2-dot">{{ fellowStoryList[i-1]?.story_title }}</p>
                </div>
            </div>
        </div>
        <!-- help -->
        <div class="mt-section">
            <div class="hstack r-container align-items-center">
                <h3 class="fs-20 fw-700">도움이 필요해요</h3>
                <span class="ms-auto fs-14 fc-gray cursor-pointer" @click="goMore('help')">더보기 ></span>
            </div>

            <div class="r-container grid-4-container r-mt-1h">
                <div
                    class="col cursor-pointer"
                    v-for="i in Math.min(8, helpAnimalList.length)"
                    :key="helpAnimalList[i-1]?.animal_idx ?? i"
                    @click="$router.push({ name: 'AnimalDetail', params: { idx: helpAnimalList[i-1]?.notify_number }})"
                    >
                    <div class="ar-11">
                        <img :src="helpAnimalList[i-1]?.image" class="of-cover br-8" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 통계 -->
    <div class="stats-sheet container" :class="{ open: statisticsOpen }" role="dialog" aria-live="polite">
        <!-- <button type="button" class="sheet-handle" @click="toggleStats" :aria-expanded="statisticsOpen">
            <span class="visually-hidden">{{ statisticsOpen ? '접기' : '펼치기' }}</span>
        </button> -->

        <div class="sheet-content">
            <div class="d-flex align-items-center mb-2">
                <div class="fw-600 fs-16">{{ statsDateText }} 유기동물 통계</div>
                <div class="ms-auto">
                    <a href="/service/statistics" class="fc-black fs-14 text-decoration-none" target="_blank">자세히 보기 &gt;</a>
                </div>
            </div>

            <div class="text-center mt-1 hstack">
                <div class="col hstack justify-content-center">
                    <div class="fs-18"><span class="fw-600 fc-black">구조</span> <span class="fw-600 fc-green">{{ statistics.today_count ?? 0 }}</span>  <span class="fw-600 fc-deep-gray">마리</span></div>
                </div>
                <div class="col hstack justify-content-center">
                    <div class="fs-18"><span class="fw-600 fc-black">입양률</span> <span class="fw-600 fc-blue">{{ (statistics.adoption_rate ?? 0).toFixed(1) }}</span>  <span class="fw-600 fc-deep-gray">%</span></div>
                </div>
                <div class="col hstack justify-content-center">
                    <div class="fs-18"><span class="fw-600 fc-black">안락사율</span> <span class="fw-600 fc-red">{{ (statistics.euth_rate ?? 0).toFixed(1) }}</span>  <span class="fw-600 fc-deep-gray">%</span></div>
                </div>
            </div>
        </div>
    </div>
    <NoticeModal v-if="showNoticeModal" :notice="recentNotice" @update:showModal="showNoticeModal = $event"></NoticeModal>
    <!-- <BottomSheet></BottomSheet> -->
</template>
<script>
// Import Swiper Vue.js components

import { db } from '@/db/db';
import { storyRepo } from '@/db/storyRepo';
import { youtubeRepo } from '@/db/youtubeRepo';
import { helpRepo } from '@/db/helpRepo';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode, Scrollbar, Mousewheel, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

import NoticeModal from '@/components/home/NoticeModal.vue';
import BottomSheet from '@/components/home/BottomSheet.vue';
import PickStoryCard from '@/components/story/PickStoryCard.vue';

const moment = require('moment');
import { ref } from 'vue';

export default {
    
    name: 'Home',
    components: {
      Swiper,
      SwiperSlide,
      BottomSheet,
      NoticeModal,
      PickStoryCard,
    },

    setup() {

    },

    data() {
        return {
            swiperModules: [Autoplay, FreeMode, Scrollbar, Mousewheel],

            bannerList : [],
            recommendedShelterList : [],
            recommendedAnimalList : [],
            campaignList : [],
            campaignAnimalList : [],
            reviewList : [],
            pickStory : null,
            pawinhandNewsList : [],
            youtubeList : [],
            fellowStoryList : [],
            helpAnimalList : [],

            quickMenuList : [],
            donationList : [],

            statistics : {},

            banner_slider_idx : 1,

            sel_shelter : {},
            sel_campaign : {},

            statisticsOpen: true, // 초기상태(열림/닫힘)

            showNoticeModal: false,
            recentNotice : null,

            showBottomSheet: false,
        };
    },

    methods: {

        getRecentNotice() {

            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('notices/recent/state', {
                params: {
                    state : "ON",
                },
            })
            .then(function (res) {
                if (res.status === 200) {

                    me.recentNotice = res.data;

                    if(me.recentNotice){
                        if (me.$cookies.get('hide_notice_idx')) {

                            let hide_notice = me.$cookies.get('hide_notice_idx');

                            if(hide_notice == me.recentNotice.notice_idx) {
                                return;
                            }else{
                                me.showNoticeModal = true;
                            }
                        }else{
                            me.showNoticeModal = true;
                        }
                        
                    }
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        getBannerList() {
            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('banners/type', {
                params: {
                    type: "main",
                    offset : "0",
                    limit : "30",
                },
            })
            .then(function (res) {
                if (res.status === 200) {

                    me.bannerList = res.data;
                    me.bannerList.sort(() => Math.random() - 0.5)
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        getRecommendedShelterList() {
            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('shelter/account/all')
            .then(function (res) {
                if (res.status === 200) {
                    let tempList = res.data.sort(() => Math.random() - 0.5)
                    me.recommendedShelterList = [...tempList, ...tempList];
                    
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        getRecommendedAnimalList() {
            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('shelter/animal/recommended/condition',{
                params: {
                    shelter_name : this.sel_shelter.idx ? this.sel_shelter.shelter_name : '', 
                    city : '모든 지역', 
                    country : '전체', 
                    species : '모든 동물', 
                    breeds : '전체',
                    offset : 0,
                    limit : 20
                }
            })
            .then(function (res) {
                if (res.status === 200) {

                    me.recommendedAnimalList = res.data;
                    me.recommendedAnimalList.sort(() => Math.random() - 0.5)
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        getHomeCategory() {
            const me = this;
            me.axios.get('category/HOME')
            .then(function(res) {
                if (res.status === 200 && res.data.length > 0) {
                    me.quickMenuList = res.data;
                } else {
                    me.quickMenuList = me.getDefaultQuickMenu();
                }
            })
            .catch(function() {
                me.quickMenuList = me.getDefaultQuickMenu();
            });
        },

        getDefaultQuickMenu() {
            return [
                { idx: 100, category_name: '포인핸드\n소개',   category_image: 'icon/category/home/quick_intro.png' },
                { idx: 200, category_name: '입양 캠페인',       category_image: 'icon/category/home/icon_quick_campaign.png' },
                { idx: 400, category_name: '지원/혜택',         category_image: 'icon/category/home/quick_benefit.png' },
                { idx: 500, category_name: '포인핸드\n스토어', category_image: 'icon/category/home/quick_store.png' },
                { idx: 600, category_name: '포인핸드\n후원',   category_image: 'icon/category/home/quick_sponsor.png' },
            ];
        },

        onQuickMenuClick(idx) {
            switch(idx) {
                case 100: this.$router.push({ name: 'Intro' }); break;
                case 200: this.$router.push({ name: 'Campaign' }); break;
                case 300: this.$router.push({ name: 'DonationList' }); break;
                case 400: this.$router.push({ name: 'Benefit' }); break;
                case 500: window.open('https://smartstore.naver.com/pawinhand', '_blank'); break;
                case 600: this.$router.push({ name: 'Sponsorship' }); break;
            }
        },

        getDonationList(){
            const me = this;

            me.axios.get(`donation`,{
                params: {
                    state : '진행중',
                    offset : 0,
                    limit : 5
                }
            })
            .then(function (res) {
                if (res.status === 200 && res.data.length > 0) {
                    me.donationList = [res.data.sort(() => Math.random() - 0.5)[0]];
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        progressPct(d) {
            const den = Number(d?.target_value) || 0;
            if (den <= 0) return 0;
            if (d?.comment_donation === 'ON') {
                return Math.floor((Number(d?.comment_donation_total_value) || 0) / den * 100);
            }
            return Math.floor((Number(d?.current_value) || 0) / den * 100);
        },

        getAdoptionCampaignList() {
            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('shelter/campaign', {
                params: {
                    state : '전체',
                    offset : 0,
                    limit : 20
                }
            })
            .then(function (res) {
                if (res.status === 200) {

                    let tempList = res.data.sort(() => Math.random() - 0.5)
                    me.campaignList = [...tempList];

                    me.sel_campaign = me.campaignList[0];

                    me.getCampaignAnimalList();
                    
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        getCampaignAnimalList() {
            const me = this;
            let ref_idx = '';
            switch(this.sel_campaign.animal_type){
                case 'SHELTER' : ref_idx = this.sel_campaign.shelter; break; 
                case 'SUPPORT' :  ref_idx = this.sel_campaign.support_idx; break; 
                case 'SUPPORT_COMPANY' :  ref_idx = this.sel_campaign.support_idx; break; 
                default : ref_idx = this.sel_campaign.support_idx; break;
            }
            

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('shelter/campaign/animal', {
                params: {
                    type : this.sel_campaign.animal_type,
                    ref_idx : ref_idx,
                    species : '모든 동물', 
                    breeds : '전체',
                    offset : 0,
                    limit : 10
                }
            })
            .then(function (res) {
                if (res.status === 200) {

                    let tempList = res.data.sort(() => Math.random() - 0.5)
                    me.campaignAnimalList = [...tempList];

                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        async getReviewList() {
            const me = this;

            const today = moment(new Date()).format('YYYY-MM-DD');

            const cached = await storyRepo.listByCategoryAndDate(2101, today);
            if (cached.length > 0) {
                me.reviewList = cached.slice().sort(() => Math.random() - 0.5);
                return;
            }

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('home/review')
            .then(function (res) {
                if (res.status === 200) {

                    me.reviewList = res.data;

                    const rows = (res.data || []).map(r => ({
                        story_idx: r.story_idx,
                        category_idx: r.category_idx,                 // ★ 통합 테이블 구분자
                        story_title: r.story_title,
                        story_contents1: r.story_contents1,
                        story_image1: r.story_image1,
                        story_r_date: r.story_r_date,
                        update_date: today           // ★ YYYY-MM-DD
                    }));

                    storyRepo.replaceCategoryForDate(2101, today, rows);

                    me.reviewList.sort(() => Math.random() - 0.5);
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        // 포인핸드 Pick: 가장 최근에 픽된 스토리 1건 (없으면 카드 미노출)
        getPickStory() {
            const me = this;

            me.axios.get('pick/story/list', {
                params: { offset: 0, limit: 1 }
            })
            .then(function (res) {
                if (res.status === 200) {
                    const list = res.data || [];
                    me.pickStory = (list.length > 0 && list[0] && list[0].story_title) ? list[0] : null;
                }
            })
            .catch(function (err) {
                console.error(err);
                me.pickStory = null;
            });
        },

        getNewsList() {
            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('home/news')
            .then(function (res) {
                if (res.status === 200) {

                    let tempList = res.data;
                    if(tempList.length > 6){
                        for(let i = 0 ; i < 6 ; i++){
                            me.pawinhandNewsList.push(tempList[i]);
                        }
                    }
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        async getYoutubeList() {
            const me = this;
            const today = moment(new Date()).format('YYYY-MM-DD');

            const cached = await youtubeRepo.listByDate(today);
            if (cached.length > 0) {
                me.youtubeList = cached.slice().sort(() => Math.random() - 0.5);
                return;
            }

            me.axios.get('home/youtube', {
                params : {
                    sort : 'idx',
                    offset : 0,
                    limit : 30
                }
            })
            .then(function (res) {
                if (res.status === 200) {

                    me.youtubeList = res.data;

                    const rows = (res.data || []).map(r => ({
                        idx: r.idx,
                        title: r.title,
                        url: r.url,
                        image: r.image,
                        update_date: today           // ★ YYYY-MM-DD
                    }));

                    youtubeRepo.replaceYoutube(rows);
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        async getFellowStoryList() {
            const me = this;
            const today = moment(new Date()).format('YYYY-MM-DD');

            const cached = await storyRepo.listByCategoryAndDate(2903, today);
            if (cached.length > 0) {
                for(let i = 0 ; i < 6 ; i++){
                    me.fellowStoryList.push(cached[i]);
                }
                return;
            }

            me.axios.get('home/fellow')
            .then(function (res) {
                if (res.status === 200) {

                    let tempList = res.data;
                    if(tempList.length > 6){
                        for(let i = 0 ; i < 6 ; i++){
                            me.fellowStoryList.push(tempList[i]);
                        }
                    }

                    const rows = (res.data || []).map(r => ({
                        story_idx: r.story_idx,
                        category_idx: r.category_idx,                 // ★ 통합 테이블 구분자
                        story_title: r.story_title,
                        story_contents1: r.story_contents1,
                        story_image1: r.story_image1,
                        story_r_date: r.story_r_date,
                        update_date: today           // ★ YYYY-MM-DD
                    }));

                    storyRepo.replaceCategoryForDate(2903, today, rows);
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        getHelpAnimalList() {
            const me = this;
            const today = moment(new Date()).format('YYYY-MM-DD');

            helpRepo.listByDate(today).then(cached => {
                if (cached.length > 0) {
                    for(let i = 0 ; i < 8 ; i++){
                        me.helpAnimalList.push(cached[i]);
                    }
                    return;
                }
            });


            me.axios.get('home/help')
            .then(function (res) {
                if (res.status === 200) {

                    let tempList = res.data;
                    if(tempList.length > 8){
                        for(let i = 0 ; i < 8 ; i++){
                            me.helpAnimalList.push(tempList[i]);
                        }
                    }

                    const rows = (res.data || []).map(r => ({
                        notify_number: r.notify_number,
                        image: r.image,
                        update_date: today           // ★ YYYY-MM-DD
                    }));

                    helpRepo.replaceHelp(rows);
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        getTodayStatistics(){
            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('home/statistics')
            .then(function (res) {
                if (res.status === 200) {

                    me.statistics = res.data
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },
        
        onSwiper(swiper) {
            const idx = Number.isFinite(swiper?.realIndex)
            ? swiper.realIndex
            : (Number.isFinite(swiper?.activeIndex) ? swiper.activeIndex : 0);
            this.banner_slider_idx = idx + 1;
        },
        onSlideChange(swiper) {
            const idx = Number.isFinite(swiper?.realIndex)
            ? swiper.realIndex
            : (Number.isFinite(swiper?.activeIndex) ? swiper.activeIndex : 0);
            this.banner_slider_idx = idx + 1;
        },
        
        goMore(section) {
            switch (section) {
                case 'recommended': this.$router.push({ name: 'ShelterList' }); break;
                case 'donation':    this.$router.push({ name: 'DonationList' }); break;
                case 'campaign':    this.$router.push({ name: 'Campaign' }); break;
                case 'review':      this.$router.push({ name: 'Story', query: { main_category_idx: 2100, sub_category_idx: 2101 } }); break;
                case 'pick':        this.$router.push({ name: 'PickStoryList' }); break;
                case 'news':        this.$router.push({ name: 'Story', query: { main_category_idx: 2400, sub_category_idx: 2404 } }); break;
                case 'youtube':     window.open('https://www.youtube.com/@pawinhand_official', '_blank'); break;
                case 'fellow':
                case 'help':
                    alert('포인핸드 앱에서 자세한 정보를 확인하세요!');
                    this.$commonUtils.goApp('home', '');
                    break;
            }
        },

        goYoutube(youtube) {
            if (youtube && youtube.url) {
                window.open(youtube.url, '_blank');
            }
        },

        /*      */
        toggleStats() {
            this.statisticsOpen = !this.statisticsOpen;
        },
       
    },

    mounted() {
        this.getHomeCategory();
        this.getRecentNotice();
        this.getBannerList();
        this.getRecommendedShelterList();
        this.getRecommendedAnimalList();
        this.getDonationList();
        this.getAdoptionCampaignList();
        this.getReviewList();
        this.getPickStory();
        this.getNewsList();
        this.getYoutubeList();
        this.getFellowStoryList();
        this.getHelpAnimalList();
        this.getTodayStatistics();
    },

    created() {},
    computed: {
        statsDateText() {
            // 예: 25.08.28 형식으로 표시
            const d = new Date();
            const pad = (n) => String(n).padStart(2, '0');
            return `${String(d.getFullYear()).slice(2)}.${pad(d.getMonth()+1)}.${pad(d.getDate())}`;
        },
    },
};
</script>


<style scoped>
    @import "@/css/common.css";
    @import "@/css/style.css";
    @import "@/css/home/home.css";

    .donation-new-badge {
        position: absolute;
        top: 0;
        left: 0;
        width: 33%;                    /* 썸네일 높이의 약 1/3 (정사각 이미지) */
        height: auto;
        object-fit: contain;
        pointer-events: none;
        border-top-left-radius: 8px;   /* 썸네일(br-8)과 동일한 좌상단 라운딩 */
    }
    @media (max-width: 1024px) {
        .donation-new-badge {
            border-top-left-radius: 4px;   /* 모바일 br-8(=4px)과 동일 */
        }
    }

    .quick-menu-title {
        @media (max-width: 768px) {
            display: none;
        }
    }

    .quick-menu-wrap {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        gap: 16px;
        padding: 16px 0px;
        justify-content: flex-start;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
    .quick-menu-wrap::-webkit-scrollbar { display: none; }

    .quick-menu-item {
        flex: 0 0 auto;
        width: 68px;
        align-items: center;
    }

    .quick-menu-icon-wrap {
        width: 52px;
        height: 52px;
        border-radius: 16px;
        background-color: #F5F7FA;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .quick-menu-icon {
        width: 32px;
        height: 32px;
        object-fit: contain;
    }

    .quick-menu-label {
        white-space: pre-line;
        text-align: center;
        line-height: 1.3;
        color: #333;
        word-break: keep-all;
    }

    /* 선형 이징으로 일정 속도 */
    :deep(.marquee-swiper .swiper-wrapper){
        transition-timing-function: linear !important;
    }

    /* 슬라이드 자체의 폭을 고정(또는 반응형) */
    :deep(.shelter-slide) {
        /* 고정 폭 */
        width: 5% !important;
        @media (max-width: 1024px) {
            width: 50px !important;
        }
    }

    :deep(.animal-slide) {
        /* 고정 폭 */
        width: 20% !important;
        @media (max-width: 1024px) {
            width: 35% !important;
        }
    }
    :deep(.campaign-slide) {
        width: auto !important;           /* ✅ 핵심 */
    }

    :deep(.news-slide) {
        width: 60% !important;           /* ✅ 핵심 */
    }
    
    :deep(.youtube-slide){
        width: 60%;
    }

    .row>* { margin-top: 0px;}

    .progress{
        height : 12px;

        @media (max-width: 1024px) {
            height : 8px;
        }
    }


</style>